export default `
  fragment articleSellerFields on ArticleSellerType {
    id
    blackSeller
    whiteSeller
    nickname
  }
`;